﻿import { Box, Drawer, IconButton, Theme, List, Divider, ListItemButton, ListItemText, styled, Toolbar, AppBar } from "@mui/material"
import {faBars} from '@fortawesome/pro-solid-svg-icons'; 
import React from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AdminRoutes } from "../../constants/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Logo from '../../assets/img/logo-white.png';

const Anchor = styled('a')({})

interface MenuLinkProps {
    path: string,
    text: string,
    external?: boolean
}

interface MobileMenuLinkProps {
    path: string,
    text: string,
    toggleDrawer: (open: boolean) => void,
}

const MobileMenuLink: React.FunctionComponent<MobileMenuLinkProps> = ({ path, text, toggleDrawer }) => {
    const location = useLocation();

    return (
        <>
            {
                path === AdminRoutes.LOGOUT ?
                    <ListItemButton
                        component="a"
                        href={path!}
                        onClick={() => toggleDrawer(false)}
                        sx={{
                            backgroundColor: location?.pathname === path ? '#502d77' : 'white',
                            color: location?.pathname === path ? 'white' : 'black',
                            '&:hover': {
                                backgroundColor: '#502d77',
                                color: 'white'
                            }
                        }}
                    >
                        <ListItemText primary={text} />
                    </ListItemButton> :
                    <ListItemButton
                        component={Link}
                        to={path!}
                        onClick={() => toggleDrawer(false)}
                        sx={{
                            backgroundColor: location?.pathname === path ? '#502d77' : 'white',
                            color: location?.pathname === path ? 'white' : 'black',
                            '&:hover': {
                                backgroundColor: '#502d77',
                                color: 'white'
                            }
                        }}
                    >
                        <ListItemText primary={text} />
                    </ListItemButton>
            }
        </>
    )
}

const MenuLink: React.FunctionComponent<MenuLinkProps> = ({ path, text, external }) => {

    const location = useLocation();

    return (
        <Box>
            {
                path === AdminRoutes.LOGOUT ?
                    <Anchor href={path} style={{ textDecoration: 'none' }}>
                        <Box
                            sx={{
                                color: 'white',
                                border: 'solid 2px',
                                borderColor: 'white',
                                borderRadius: '4px',
                                '&:hover': {
                                    borderColor: '#502d77',
                                    color: '#502d77',
                                },
                                py: 1,
                                px: 2,
                                mx: 2
                            }}
                        >
                            {text}
                        </Box>
                    </Anchor> :
                    <Link to={path} target={external ? "_blank" : "_self"} style={{ textDecoration: 'none' }}>
                        <Box
                            sx={{
                                color: 'white',
                                backgroundColor: location?.pathname === path ? '#502d77' : 'secondary',
                                borderColor: 'white',
                                borderRadius: '4px',
                                '&:hover': {
                                    borderColor: '#502d77',
                                    backgroundColor: '#502d77'
                                },
                                py: 1,
                                px: 2,
                                mx: 2
                            }}
                        >
                            {text}
                        </Box>
                    </Link>
            }
        </Box>
    )
}

const AdminNavigation: React.FunctionComponent = () => {

    const location = useLocation();

    const [openMenu, setOpenMenu] = React.useState<boolean>(false);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        let anchor = event.currentTarget
        setAnchorEl(anchor);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleDrawer = React.useCallback((value: boolean) => {
        setOpenMenu(value)
    }, [])

    return (
        <Box>
            <AppBar color='secondary' position="static">
                <Toolbar>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}>

                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: {
                                xs: '100px',
                                md: '120px'
                            },
                            '& img': {
                                width: '100%'
                            }
                        }}>
                            <a href="/"><img src={Logo}/></a>
                        </Box>
                        {
                            <>
                                <Box
                                    className="desktopDiv"
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            height: '100%',

                                        }}
                                    >
                                        <MenuLink
                                            path={AdminRoutes.HOME}
                                            text="Home"
                                        />
                                        <MenuLink
                                            path={AdminRoutes.ADMIN_REGISTRATIONS}
                                            text="Registrations"
                                        />
                                        <MenuLink
                                            path={AdminRoutes.ADMIN_SPONSOR}
                                            text="Sponsors"
                                        />
                                        
                                        <MenuLink
                                            path={AdminRoutes.ADMIN_SPEAKER}
                                            text="Custom Registrations"
                                        />
                                        <MenuLink
                                            path={AdminRoutes.ADMIN_CERTIFICATES}
                                            text="Certificates"
                                        />
                                        <MenuLink
                                            path={AdminRoutes.ADMIN_REPORTS}
                                            text="Reports"
                                        />
                                         <MenuLink
                                            path={AdminRoutes.ADMIN_PRINTING }
                                            text="Printing"
                                        />
                                        <MenuLink
                                            path={AdminRoutes.LOGOUT}
                                            text="Logout"
                                        />
                                    </Box>
                                </Box>
                            </>
                        }
                        </Box>
                </Toolbar>
            </AppBar>
        </Box>
)
}

export default AdminNavigation;